import { render, staticRenderFns } from "./AddVirtualColumn.vue?vue&type=template&id=de0ca8cc"
import script from "./AddVirtualColumn.vue?vue&type=script&lang=js"
export * from "./AddVirtualColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports